export default __webpack_public_path__ + "static/media/app-ftz-01.49c45457.png";